/** Retry policy for websocket connection
  The attempt delay is going to follow the following pattern:
  2 seconds, 2 seconds, 3 seconds, 3 seconds, 5 seconds, 5 seconds, 10 seconds, and finally 10 seconds
  After the predefined retries, the delay will be incremental by 5 seconds
  The maximum delay is capped at 2 minutes
*/
export const websocketRetryPolicy = (context) => {
    // Attempt number
    const attempt = context.previousRetryCount + 1;
    // Define retry delays in milliseconds
    const retryDelays = [2000, 2000, 3000, 3000, 5000, 5000, 10000, 10000];
    const maxDelay = 120000; // Maximum delay capped at 2 minutes
    const incrementalDelay = 5000; // Incremental delay after the predefined retries
    let delay = 0;
    if (attempt <= retryDelays.length) {
        delay = retryDelays[attempt - 1];
    }
    else {
        delay = retryDelays[retryDelays.length - 1] + incrementalDelay * (attempt - retryDelays.length);
        if (delay > maxDelay) {
            delay = maxDelay;
        }
    }
    return delay;
};
//# sourceMappingURL=websocketRetryPolicy.js.map